/**
 * API Configuration
 * Uses relative paths so the app works on any domain
 */

// Use relative path for same-origin requests (works on any domain)
// Falls back to env variable only for local development
const getApiBase = () => {
  // In production, use relative path (same origin)
  if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
    return '/api';
  }
  // In local development, use the env variable
  return `${process.env.REACT_APP_BACKEND_URL || ''}/api`;
};

export const API_BASE = getApiBase();

// For WebSocket connections
export const getWsUrl = () => {
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}`;
  }
  return process.env.REACT_APP_BACKEND_URL?.replace('http', 'ws') || '';
};

export default API_BASE;

// Clave de idempotencia por intento (cobros y pedidos)
export const idem = () => ({
  headers: {
    'Idempotency-Key': (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`)
  }
});

// Archivos privados (ej. planos): agrega el token para usarlos en <img>/CSS
export const withFileAuth = (url) => {
  const token = localStorage.getItem('token');
  if (!url || !token || !url.includes('/api/files/')) return url;
  return `${url}${url.includes('?') ? '&' : '?'}auth=${encodeURIComponent(token)}`;
};
